/* eslint-disable */ import { attachSingleReferenceComponent, composedOfComponent, detailComponent, memoEval, referenceComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { BottomCabinetAppliance } from '../model/index.js';
export const bottomCabinetWithApplianceComponents = [
    attachSingleReferenceComponent(attachComponent.withComponent(referenceComponent, 'BottomCabinetWithAppliance.$appliance', true).withAlias('BottomCabinetWithAppliance'), BottomCabinetAppliance, 'applianceId'),
    attachComponent.withComponent(composedOfComponent, '$appliance', true).withAlias('BottomCabinetWithAppliance').attach(memoEval((self)=>[
            self.$appliance?.id ?? null
        ], (id)=>({
            childEntityIds: id === null ? [] : [
                id
            ]
        }))),
    attachComponent.withComponent(detailComponent, 'default', true).withAlias('BottomCabinetWithAppliance').attach(memoEval((self)=>[
            self.$applianceName,
            self.$applianceSku,
            self.$applianceDescription,
            self.$thumbnailUrl
        ], ($applianceName, $applianceSku, $applianceDescription, $thumbnailUrl)=>({
            title: $applianceName,
            subtitle: $applianceSku,
            description: $applianceDescription,
            thumbnailUrl: $thumbnailUrl
        })))
];

//# sourceMappingURL=bottom-cabinet-with-appliance.js.map